// src/services/edgeFunctionService.js
import { supabase } from '../lib/supabase'

export const edgeFunctionService = {
  async analyzeStimulus(content) {
    const { data, error } = await supabase.functions.invoke('analyze_stimulus', {
      body: { content }
    })

    if (error) {
      throw new Error(`Failed to analyze stimulus: ${error.message}`)
    }

    return data
  },

  async generateLessonPlan(lessonDesignId) {
    const { data, error } = await supabase.functions.invoke('generate_lesson_plan', {
      body: { lessonDesignId }
    })

    if (error) {
      throw new Error(`Failed to generate lesson plan: ${error.message}`)
    }

    return data
  },

  async generateLessonResources(lessonDesignId) {
    const { data, error } = await supabase.functions.invoke('generate_lesson_resources', {
      body: { lessonDesignId }
    })

    if (error) {
      throw new Error(`Failed to generate lesson resources: ${error.message}`)
    }

    if (!data?.success) {
      throw new Error(data?.error || 'Lesson resource generation failed')
    }

    return data
  },

  async extractStimulusText(stimulusId) {
    const { data, error } = await supabase.functions.invoke('extract_stimulus_text', {
      body: { stimulusId },
    })

    if (error) {
      throw new Error(`Failed to extract stimulus text: ${error.message}`)
    }

    if (!data?.success) {
      throw new Error(data?.error || 'Stimulus text extraction failed')
    }

    return data
  }
}